import { make } from 'redux-chill';

import type { Parameters } from '@features/delivery/add-parameters';

const setParametersInfo = make('[delivery] set parameters')
  .stage((info: Parameters) => ({ info }))
  .stage('reset');

export { setParametersInfo };
